import React from "react";
import ReactCardFlipper from "react-card-flipper";
import "../Cards/Cards.css";
import "./Card.css";
import {useMediaQuery} from "../CustomMediaQueryHook/useMediaQuery.jsx";

const Card = (props) => {

  let isPageWide = useMediaQuery('(max-width: 900px)')

  return (
    <div className="card-flex-item">
      <ReactCardFlipper
        height={!isPageWide?"17em":"12em"}
        width={!isPageWide?"350px":"9em"}
        behavior="click"
        levitate={false}
      >
        <div className="card">
          <img alt="card_image" src={props.image} className="rounded-corners" />
          <h4>
            <b>{props.content}</b>
          </h4>
        </div>
        <div className="card">
          <h4>{props.content}</h4>
          <p
            className="card-text"
            // style={{ fontSize: "1.35em", padding: "0.2em", fontWeight: "500" }}
          >
            {props.text}
          </p>
        </div>
      </ReactCardFlipper>
    </div>
  );
};

export default Card;
